'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();
import { Button } from '@qogita/ui/v2/button'
import { ComponentProps } from 'react'

export function PrintButton(
  props: Omit<ComponentProps<typeof Button>, 'onClick'>,
) {
  return <Button {...props} onClick={() => window.print()} />
}
